import { tournamentFormatter } from '../common/formatters/tournamentFormatter';
import { tournamentEngine } from 'tods-competition-factory';
import { context } from 'services/context';

import { TOURNAMENT } from 'constants/tmxConstants';
import { t } from 'i18n';

export function getTournamentColumns(): any[] {
  const isMobile = /Mobile/.test(navigator.userAgent);
  const openTournament = (_: any, cell: any) => {
    const tournamentId = cell.getRow().getData().tournamentId;

    if (tournamentId) {
      tournamentEngine.reset();
      const tournamentUrl = `/${TOURNAMENT}/${tournamentId}`;
      context.router?.navigate(tournamentUrl);
    }
  };

  return [
    {
      formatter: tournamentFormatter(isMobile),
      cellClick: openTournament,
      field: 'tournament',
      headerSort: false,
      resizable: true,
      minWidth: 250,
      widthGrow: 3,
    },
    {
      formatter: () => `<div class="button font-medium">${t('tables.tournaments.open')}</div>`,
      cellClick: openTournament,
      vertAlign: 'middle',
      visible: !isMobile,
      title: t('tables.tournaments.open'),
      width: 90,
    },
  ];
}
